import React, { useEffect, useState } from 'react';
import { formatMoney_2 } from '../../../../helpers/DateFormat';
import Container from '../../../../constants/Container';

interface ProfitLossRptListViewProps {
    onProfitLossReport: any;
}

const ProfitLossRptListView: React.FC<ProfitLossRptListViewProps> = ({ onProfitLossReport }) => {
    const [totalAmt, setOnTotalAmt] = useState({ totalDRAmt: 0, totalCRAmt: 0 });

    useEffect(() => {
        const totalDrAmount = onProfitLossReport?.results
            ? onProfitLossReport?.results.reduce((total: number, voucher: any) => total + (voucher?.particuamt || 0), 0)
            : 0;

        const totalCRAmount = onProfitLossReport?.results
            ? onProfitLossReport?.results.reduce((total: number, voucher: any) => total + (voucher?.currentyear || 0), 0)
            : 0;

        setOnTotalAmt({ totalDRAmt: totalDrAmount, totalCRAmt: totalCRAmount });
    }, [onProfitLossReport]);

    return (
        <Container padding>
            <div className="relative overflow-x-auto overflow-y-scroll !h-[75vh]">
                <table className="text-sm text-left rtl:text-right text-slate-800 whitespace-nowrap scroll-x-auto dark:text-gray-400 rounded w-full">
                    <thead className="text-[12px] text-gray700 bg-slate-100 dark:bg-sky-950 capitalize border-b dark:bg-slate900 dark:text-slate-400 font-public-sans">
                        <tr>
                            <th align='center' className="px-2 border border-gray-300 dark:border-sky-800 w-10">S.N.</th>
                            <th align='center' className="px-2 border border-gray-300 dark:border-sky-800 w-10">GLID</th>
                            <th align='center' className="px-2 border border-gray-300 dark:border-sky-800">Particulars</th>
                            <th align='center' className="px-2 border border-gray-300 dark:border-sky-800">Current Year</th>
                            <th align='center' className="px-2 border border-gray-300 dark:border-sky-800">Remarks</th>
                        </tr>
                    </thead>
                    <tbody className='text-slate-800'>
                        {Array.isArray(onProfitLossReport?.results) &&
                            onProfitLossReport.results.map((voucher: any, index: number) => (
                                <tr key={index} className="odd:bg-white hover:bg-slate-100 text-[12px] text-gray-800 dark:text-gray-400 odd:dark:bg-sky-900 even:bg-slate-50 even:dark:bg-sky-800 border-b font-public-sans dark:border-gray-700">
                                    <td align='center' className="px-2 font-medium py-0.5 border border-gray-300 dark:border-sky-800 capitalize text-[11px]">
                                        {index + 1}.
                                    </td>
                                    <td align='left' className="px-2 font-medium py-0.5 border border-gray-300 dark:border-sky-800 capitalize text-[11px]">
                                        {voucher?.glid || ""}
                                    </td>
                                    <td align='left' className="px-2 font-medium py-0.5 border border-gray-300 dark:border-sky-800 capitalize text-[11px]">
                                        <span className='font-bold underline-offset-1'>{voucher?.subledgname}</span>
                                        {voucher?.particuid && (
                                            <div className='flex justify-between'>
                                                <span className='pl-9 font-normal'>{voucher?.particularname}</span>
                                                <span className='pl-9 font-normal'>{formatMoney_2(voucher?.particuamt || 0)}</span>
                                            </div>
                                        )}
                                    </td>
                                    <td align='right' className="px-2 font-medium py-0.5 border border-gray-300 dark:border-sky-800 capitalize text-[11px]">
                                        {formatMoney_2(voucher?.currentyear || 0)}
                                    </td>
                                    <td align='left' className="px-2 font-medium py-0.5 border border-gray-300 dark:border-sky-800 capitalize text-[11px]"></td>
                                </tr>
                            ))
                        }
                        <tr className="odd:bg-white hover:bg-slate-100 text-[12.5px] font-bold text-gray-800 dark:text-gray-400 odd:dark:bg-sky-900 even:bg-slate-50 even:dark:bg-sky-800 border-b font-public-sans dark:border-gray-700">
                            <td align='right' colSpan={2} className="px-2 border border-gray-300 dark:border-sky-800">
                                Total
                            </td>
                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                {formatMoney_2(totalAmt.totalDRAmt)}
                            </td>
                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800">
                                {formatMoney_2(totalAmt.totalCRAmt)}
                            </td>
                            <td align='right' className="px-2 border border-gray-300 dark:border-sky-800"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Container>
    );
};

export default ProfitLossRptListView;
